import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import usegetdata from '../../Hooks/useGetData';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import {
  Add_Rotation_Type,
  Delete_One_Rotation_Type,
  Get_All_Rotation_Type,
  Get_Error,
  Get_One_Rotation_Type,
  Update_One_Rotation_Type,
} from '../Types';

//add all cities data
export const Add_Rotation_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/rotation`, body);

    dispatch({
      type: Add_Rotation_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const GetAll_Rotation_Data = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/rotation`);

    dispatch({
      type: Get_All_Rotation_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one region data
export const DeleteOne_Rotation_Data = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/rotation/${id}`);

    dispatch({
      type: Delete_One_Rotation_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one city data
export const UpdateOne_Rotation_Data = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/rotation/${id}`, body);

    dispatch({
      type: Update_One_Rotation_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one cities data
export const GetOne_Rotation_Data = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/rotation/${id}`);

    dispatch({
      type: Get_One_Rotation_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
